import React from "react";
import PropTypes from "prop-types";
import "../../assets/scss/_exitmodal.scss";
import "../../assets/scss/_reject-modal.scss";
import closeIcon from "../../assets/icons/Close.png";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="exit-consultation-overlay">
      <div
        aria-modal="true"
        className="exit-consultation-modal confirm-modal"
        role="dialog"
      >
        <div className="exit-consultation-modal__header">
          <h2 className="exit-consultation-modal__title">{title}</h2>
          <button
            aria-label="Close"
            className="exit-consultation-modal__close"
            onClick={onClose}
            type="button"
          >
            <img alt="" height="24" src={closeIcon} width="24" />
          </button>
        </div>

        <div className="exit-consultation-modal__body confirm-modal__body">
          {children}
        </div>

        <div className="exit-consultation-modal__footer">
          <button
            className="exit-consultation-modal__confirm"
            onClick={onConfirm}
            type="button"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  confirmLabel: PropTypes.string,
};

ConfirmModal.defaultProps = {
  confirmLabel: "Confirm",
};

export default ConfirmModal;